module.exports = __webpack_public_path__ + "static/img/about_img_honour01.753cee4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guanyu/about_img_honour01.png
// module id = 2buD
// module chunks = 1